// SelectInput.tsx

import React, { ChangeEvent } from 'react'
import './SelectInput.scss'
import { BlurEvent, FieldError } from 'common.types'
import { getInputClasses } from 'utilities/utilities'
import { InputStatusIcon, FieldErrorList, RequiredBar } from 'components'

interface SelectInputProps {
  label: string
  value: string
  required?: boolean
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void
  options: { value: string; label: string }[]
  name: string
  emptyOptionLabel: string
  disabled?: boolean
  onBlur?: (e: BlurEvent) => void
  errorList?: FieldError[]
}

export const SelectInput: React.FC<SelectInputProps> = ({
  label,
  value,
  onChange,
  required = false,
  options,
  name,
  emptyOptionLabel,
  disabled,
  errorList,
  onBlur,
}) => {
  const errorsExist = errorList && errorList.length > 0
  const inputEntered = value ? true : false
  return (
    <div className="input-wrapper select-input">
      <label htmlFor={name} className="select-input__label">
        {required && (
          <span className="select-input__label__required-asterisk">*</span>
        )}
        {label}
      </label>
      <div
        className={`select-input__select ${getInputClasses(
          errorsExist,
          inputEntered,
        )}`}
      >
        <RequiredBar
          isRequired={required}
          errorsExist={errorsExist}
          inputEntered={inputEntered}
        />
        <select
          name={name}
          required={required}
          className="select-input__select__select"
          value={value}
          onChange={onChange}
          disabled={disabled}
          onBlur={(e) => {
            if (onBlur) {
              onBlur(e as any)
            }
          }}
        >
          <option value="">{emptyOptionLabel}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <InputStatusIcon
          errorsExist={errorsExist ? true : false}
          inputEntered={inputEntered}
        />
      </div>
      <FieldErrorList errorListForField={errorList} />
    </div>
  )
}
